import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  settings: 'Settings',
  feesAndPromotions: 'FeesAndPromotions', // use this tag once we set up endpoint to update fees and promotions
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.settings, TAG_TYPES.feesAndPromotions],
  endpoints: {
    getSettings: {
      providesTags: () => [{ type: TAG_TYPES.settings }],
    },
    updateSettings: {
      invalidatesTags: () => [{ type: TAG_TYPES.settings }],
    },
    postSettingsRbac: {
      invalidatesTags: () => [{ type: TAG_TYPES.settings }],
    },
    getFpSettings: {
      providesTags: result =>
        result?.Items
          ? [
              ...result.Items.map(({ id }) => ({ type: TAG_TYPES.feesAndPromotions, id })),
              { type: TAG_TYPES.feesAndPromotions, id: 'LIST' },
            ]
          : [{ type: TAG_TYPES.feesAndPromotions, id: 'LIST' }],
    },
    createFeeOrPromotionPreset: {
      invalidatesTags: () => [{ type: TAG_TYPES.feesAndPromotions, id: 'LIST' }],
    },
    updateFeeOrPromotionPreset: {
      invalidatesTags: (_result, _error, { feeOrPromotionId }) => [
        { type: TAG_TYPES.feesAndPromotions, id: feeOrPromotionId },
        { type: TAG_TYPES.feesAndPromotions, id: 'LIST' },
      ],
    },
    archiveFeeOrPromotionPreset: {
      // same as update: remove or change one preset, so bump both
      invalidatesTags: (_result, _error, { feeOrPromotionId }) => [
        { type: TAG_TYPES.feesAndPromotions, id: feeOrPromotionId },
        { type: TAG_TYPES.feesAndPromotions, id: 'LIST' },
      ],
    },
  },
})

export const {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
  usePostSettingsRbacMutation,
  useGetFpSettingsQuery,
  useCreateFeeOrPromotionPresetMutation,
  useUpdateFeeOrPromotionPresetMutation,
  useArchiveFeeOrPromotionPresetMutation,
} = api
